import axios from 'axios'

import {api_url} from "../config/site";

const instance = axios.create({
    baseURL: api_url,
});

instance.interceptors.request.use(function (config) {

    /*用户登录标识*/
    // config.headers.authorization = localStorage.getItem('token') ? 'Bearer ' + encodeURIComponent(localStorage.getItem('token')) : '';
    // 是否是灰度线上环境
    let environmentUrl = window.location.href.indexOf('croaker.xiaomaiyuyin.com') != -1
    if(environmentUrl) {
        config.headers.Tenant_Id = "green"
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});

export default instance;
